import { defineStore } from 'pinia'
import { RxStore } from '~/stores/rx'
import { ProviderStore } from '~/stores/provider'
import { QuoteChangeMonitor } from '~/composables/QuoteChangeMonitor'

// Freeze ghost card visible state until engine run completes
export class InsuranceNeedsVisibilityGateStore {
  static use = defineStore('insurance-needs-visibility-gate', () => {
    const rxStore = RxStore.use()
    const providerStore = ProviderStore.use()
    const { isInsuranceDiff } = QuoteChangeMonitor.use()

    const liveHasDrugsOrDocs = computed(
      () => rxStore.rxs.length > 0 || providerStore.providers.length > 0
    )

    const hasDrugsOrDocsApplied = ref(liveHasDrugsOrDocs.value)

    watch([liveHasDrugsOrDocs, isInsuranceDiff], () => {
      if (!isInsuranceDiff.value) hasDrugsOrDocsApplied.value = liveHasDrugsOrDocs.value
    })

    return {
      hasDrugsOrDocsApplied
    }
  })
}
